<template>
  <div>
    <div class="content" :key="'field'+index" v-for="(item,index) in fieldList">
      <div class="close">
        <el-button type="text" @click="moveField(index,'up')">向上移动</el-button>
        <el-button type="text" @click="moveField(index,'down')">向下移动</el-button>
        <el-button @click="delField(index)" type="text">删除</el-button>
      </div>
      <div class="field">
        <el-input v-model="item.field" placeholder="请输入字段名" style="width: 100%">
          <template slot="prepend">字段名</template>
        </el-input>
      </div>
      <div class="field">
        <template>
          <el-radio-group @input="changeFieldType(index,item.field_type)" v-model="item.field_type">
            <el-radio label="text">文本类型</el-radio>
            <el-radio label="image">图片类型</el-radio>
          </el-radio-group>
        </template>
      </div>
      <div class="text">
        <el-input v-if="item.field_type === 'text'" v-model="item.value" rows="10" type="textarea"
                  placeholder="请输入字段内容"></el-input>
        <iUpload v-else v-model="item.value"></iUpload>
      </div>
    </div>
    <div class="opt">
      <el-button type="primary" plain @click="addField"> +增加字段</el-button>
    </div>
  </div>
</template>

<script>
import iUpload from "@/components/i-upload"

export default {
  name: "i-field",
  props: {
    value: []
  },
  components: {
    iUpload
  },
  data: function () {
    return {
      fieldList: []
    }
  },
  methods: {
    addField: function () {
      this.fieldList.push({field: "", value: "", field_type: "text"});
    },
    delField: function (index) {
      this.fieldList.splice(index, 1)
    },
    changeFieldType: function (index, type) {
      this.fieldList[index].value = type === 'image' ? [] : "";
    },
    moveField:function (index,direction){
      if(index === 0 && direction === 'up'){
        return false;
      }
      if(index === (this.fieldList.length - 1) && direction === 'down'){
        return false;
      }
      if(direction === 'down'){
        const temp = this.fieldList[index];
        this.fieldList[index]  = this.fieldList[index + 1];
        this.fieldList[index + 1] = temp;
      }
      if(direction === 'up'){
        const temp = this.fieldList[index];
        this.fieldList[index] = this.fieldList[index - 1];
        this.fieldList[index - 1] = temp;
      }
      this.$forceUpdate();
    }
  },
  created() {
    this.fieldList = this.value;
  },
  watch: {
    fieldList: function () {
      this.$emit('input', this.fieldList);
    },
    value: function () {
      this.fieldList = this.value;
    }
  }
}
</script>

<style scoped lang="less">
.content {
  border-bottom: 1px dashed #ccc;
  padding: 0 10px 20px 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  position: relative;

  .close {
    position: absolute;
    right: 0;
    top: 0;
    color: #F56C6C;
    cursor: pointer;
  }

  .field {
    margin-bottom: 10px;
    width: 85%;
  }

  .text {
    width: 85%;

  }
}

.opt {
  padding: 20px 0;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/i-field.vue